import React from "react";
import Card from "components/card";
import { BiaFitUser } from "../../types/user";

interface UserAccountInfoCardProps {
  user: BiaFitUser;
}

const UserAccountInfoCard: React.FC<UserAccountInfoCardProps> = ({ user }) => (
  <Card extra="w-full p-3 md:p-6">
    <h2 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
      Account Information
    </h2>

    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-500 dark:text-gray-400">
          User ID
        </label>
        <p className="text-navy-700 dark:text-white">{user.id}</p>
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium text-gray-500 dark:text-gray-400">
          Account Status
        </label>
        <p className="text-navy-700 dark:text-white">
          {user.is_active ? "Active Account" : "Inactive Account"}
        </p>
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium text-gray-500 dark:text-gray-400">
          Member Since
        </label>
        <p className="text-navy-700 dark:text-white">
          {new Date(user.created_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium text-gray-500 dark:text-gray-400">
          Account Age
        </label>
        <p className="text-navy-700 dark:text-white">
          {Math.floor(
            (new Date().getTime() - new Date(user.created_at).getTime()) /
              (1000 * 60 * 60 * 24)
          )}{" "}
          days
        </p>
      </div>
    </div>
  </Card>
);

export default UserAccountInfoCard;
